import { DatafeedCoreBase } from "./datafeed.core.base"


export class DatafeedCore extends DatafeedCoreBase {

}